module.exports = __webpack_public_path__ + "media/images/aloe/icons/categories/kitchen-8d32681206cbdbe7689ee1324e9a0305.svg";